var _defs, _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _style, _symbol6, _symbol7, _symbol8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEg2023Sprites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 262.873h744.074V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221 43h6.867v8H221Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 35h7.867v9H220Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C7.402 0 0 7.402 0 16.5 0 25.598 7.402 33 16.5 33 25.598 33 33 25.598 33 16.5 33 7.402 25.598 0 16.5 0Zm5.858 29.394a14.082 14.082 0 0 1-5.858 1.27c-2.088 0-4.072-.455-5.858-1.27v-5.71c0-1.61 1.309-2.918 2.918-2.918h5.88c1.61 0 2.918 1.309 2.918 2.918v5.71Zm2.337-1.347v-4.363a5.26 5.26 0 0 0-5.255-5.254h-.292a6.148 6.148 0 0 0 3.492-5.54 6.147 6.147 0 0 0-6.14-6.14 6.147 6.147 0 0 0-6.14 6.14 6.148 6.148 0 0 0 3.492 5.54h-.292a5.26 5.26 0 0 0-5.255 5.254v4.363c-3.61-2.57-5.969-6.788-5.969-11.547C2.336 8.69 8.69 2.336 16.5 2.336S30.664 8.69 30.664 16.5c0 4.759-2.36 8.977-5.97 11.547ZM16.5 16.695a3.808 3.808 0 0 1-3.804-3.805A3.808 3.808 0 0 1 16.5 9.086a3.808 3.808 0 0 1 3.804 3.804 3.808 3.808 0 0 1-3.804 3.805Z",
    id: "a"
  }))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 408.788 408.788"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.701 0H55.087C24.665 0 .002 24.662.002 55.085v298.616c0 30.423 24.662 55.085 55.085 55.085h147.275l.251-146.078h-37.951a8.954 8.954 0 0 1-8.954-8.92l-.182-47.087a8.955 8.955 0 0 1 8.955-8.989h37.882v-45.498c0-52.8 32.247-81.55 79.348-81.55h38.65a8.955 8.955 0 0 1 8.955 8.955v39.704a8.955 8.955 0 0 1-8.95 8.955l-23.719.011c-25.615 0-30.575 12.172-30.575 30.035v39.389h56.285c5.363 0 9.524 4.683 8.892 10.009l-5.581 47.087a8.955 8.955 0 0 1-8.892 7.901h-50.453l-.251 146.078h87.631c30.422 0 55.084-24.662 55.084-55.084V55.085C408.786 24.662 384.124 0 353.701 0z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "flame",
    viewBox: "0 0 228.6 285.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.6 151.6c1.2 1.4 2.3 2.9 3.3 4.4l27.5-14.2c-1.4-1-2.9-1.9-4.3-2.8-2.8-1.7-5.5-3.6-7.9-5.8l-21.8 14c.9 1.6 2 3.1 3.2 4.4M86 160.2l-47.7 30.7 45.5-23.4c.4-2.5 1.2-5 2.2-7.3M85.8 186.5c-.6-1.4-1.1-2.9-1.5-4.4l-40 25.8 41.5-21.4zM93.1 197.2l-40.3 26c0 .1.1.1.1.2l44.2-22.8c-1.4-1-2.8-2.1-4-3.4M60.8 99.4l21.6-11.1c-1.2-2.2-2.6-4.4-4-6.5L61.9 92.5v.1c-.3 2.3-.6 4.6-1.1 6.8M137.6 59.9c-.9-4.7-2.2-9.3-3.8-13.7l-19.1 12.3c-4.9 9.9-12.3 18.3-21.5 24.3l44.4-22.9zM116.5 206.9c-1.8 0-3.6-.2-5.4-.4l-46.5 29.9c.2.2.5.4.7.6l61.8-31.9c-3.3 1.2-6.8 1.8-10.6 1.8M139 74.6c0-3.6-.2-7.1-.7-10.5l-83.4 53.7c-1 2.2-2.1 4.3-3.3 6.4l87.3-45c0-1.5.1-3.1.1-4.6M40 148.2c-.2.8-.4 1.5-.7 2.3l94.9-48.9c1.4-4 2.6-8.2 3.4-12.6.2-1.4.5-2.7.6-4.1L40 148.2zM149.8 173.5l36-18.6c-3-4-6.5-7.6-10.4-10.7L147.8 162c1.3 3.6 2 7.4 2 11.5M195.3 173 79.9 247.4c.7.4 1.3.7 2 1.1l116.2-59.9c-.2-5.4-1.2-10.6-2.8-15.6M198.2 192l-98.5 63.5c1.7.5 3.4.9 5.1 1.2l90.7-46.7c1.7-5.7 2.7-11.8 2.7-18M118.1 49.9l14.2-7.3c-3.1-7.1-7.2-13.6-12.1-19.4.4 2.8.6 5.7.6 8.6 0 6.3-.9 12.4-2.7 18.1M127.8 258.1c18.1-1.3 34.6-8.1 47.9-18.9.2-.1.3-.3.5-.4.1 0 .1-.1.2-.1s.1-.1.2-.1c.2-.1.3-.3.5-.4 7-6 12.5-13.5 16.2-22.1l-65.5 42zM72.1 73.6C68.3 69.3 64 65.4 59.3 62c1.5 5.4 2.5 11 2.9 16.7l9.9-5.1zM148.7 182.2c-2 7.5-6.6 13.9-12.7 18.3l58.4-30.1c-1.8-4.7-4.1-9.2-6.9-13.3l-38.8 25.1zM133.3 129.7v1.2c.1 3.5.8 6.9 2 10.1l21.6-11.1c-2.8-3.2-5.2-6.9-7.1-10.8l-16.5 10.6zM134.4 121.5l13.6-7c-1.2-3.4-1.9-7-2.3-10.7-5.5 4.4-9.6 10.6-11.3 17.7M36.4 172l79-40.7c6-5.9 11-12.8 14.9-20.4l-93.9 60.5v.6"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "flame_trama",
    viewBox: "0 0 333.6 314.9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.2 141.3 97.9 142.3 203.3-130.9-136 70.1 129.8-83.4-143.7 74 133.3-85.6-136.5 70.4L290 115.5l-138.7 71.4 133.9-86-135.9 70 131.6-84.5-139.4 71.8 130.2-83.6-139.9 72.1 129.1-83-143.1 73.8 137.9-88.4-139.6 72.4 133.7-85.8-139.2 71.7L239 24.9 33.8 130.6l.1.1z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "image",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.575 0H65.425C29.349 0 0 29.35 0 65.426v381.149C0 482.65 29.349 512 65.425 512h381.15C482.651 512 512 482.65 512 446.574V65.426C512 29.35 482.651 0 446.575 0zm35.267 446.575c0 19.447-15.821 35.267-35.267 35.267H65.425c-19.447 0-35.268-15.821-35.268-35.267v-55.007l99.255-84.451a9.745 9.745 0 0 1 12.562-.075l62.174 51.628c5.995 4.977 14.795 4.569 20.304-.946L372.181 209.77c2.67-2.675 5.783-2.935 7.408-2.852 1.62.083 4.695.661 7.078 3.596l95.176 117.19v118.871zm0-166.71-71.766-88.366a39.98 39.98 0 0 0-28.942-14.701c-11.268-.57-22.317 3.672-30.294 11.662L212.832 326.681l-51.59-42.839a39.85 39.85 0 0 0-51.373.308l-79.712 67.822V65.426c0-19.447 15.821-35.268 35.268-35.268h381.15c19.447 0 35.267 15.821 35.267 35.268v214.439z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.174 62.995c-40.095 0-72.713 32.62-72.713 72.713 0 40.094 32.619 72.713 72.713 72.713s72.713-32.619 72.713-72.713-32.618-72.713-72.713-72.713zm0 115.269c-23.466 0-42.556-19.091-42.556-42.556 0-23.466 19.09-42.556 42.556-42.556 23.466 0 42.556 19.091 42.556 42.556s-19.09 42.556-42.556 42.556z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "instagram",
    viewBox: "0 0 511 511.9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.95 150.5c-1.2-27.2-5.598-45.898-11.9-62.102-6.5-17.199-16.5-32.597-29.6-45.398-12.802-13-28.302-23.102-45.302-29.5-16.296-6.3-34.898-10.7-62.097-11.898C334.648.3 325.949 0 256.449 0s-78.199.3-105.5 1.5c-27.199 1.2-45.898 5.602-62.097 11.898-17.204 6.5-32.602 16.5-45.403 29.602-13 12.8-23.097 28.3-29.5 45.3-6.3 16.302-10.699 34.9-11.898 62.098C.75 177.801.449 186.5.449 256s.301 78.2 1.5 105.5c1.2 27.2 5.602 45.898 11.903 62.102 6.5 17.199 16.597 32.597 29.597 45.398 12.801 13 28.301 23.102 45.301 29.5 16.3 6.3 34.898 10.7 62.102 11.898 27.296 1.204 36 1.5 105.5 1.5s78.199-.296 105.5-1.5c27.199-1.199 45.898-5.597 62.097-11.898a130.934 130.934 0 0 0 74.903-74.898c6.296-16.301 10.699-34.903 11.898-62.102 1.2-27.3 1.5-36 1.5-105.5s-.102-78.2-1.3-105.5zm-46.098 209c-1.102 25-5.301 38.5-8.801 47.5-8.602 22.3-26.301 40-48.602 48.602-9 3.5-22.597 7.699-47.5 8.796-27 1.204-35.097 1.5-103.398 1.5s-76.5-.296-103.403-1.5c-25-1.097-38.5-5.296-47.5-8.796C94.551 451.5 84.45 445 76.25 436.5c-8.5-8.3-15-18.3-19.102-29.398-3.5-9-7.699-22.602-8.796-47.5-1.204-27-1.5-35.102-1.5-103.403s.296-76.5 1.5-103.398c1.097-25 5.296-38.5 8.796-47.5C61.25 94.199 67.75 84.1 76.352 75.898c8.296-8.5 18.296-15 29.398-19.097 9-3.5 22.602-7.7 47.5-8.801 27-1.2 35.102-1.5 103.398-1.5 68.403 0 76.5.3 103.403 1.5 25 1.102 38.5 5.3 47.5 8.8 11.097 4.098 21.199 10.598 29.398 19.098 8.5 8.301 15 18.301 19.102 29.403 3.5 9 7.699 22.597 8.8 47.5 1.2 27 1.5 35.097 1.5 103.398s-.3 76.301-1.5 103.301zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45 124.5c-72.598 0-131.5 58.898-131.5 131.5s58.902 131.5 131.5 131.5c72.6 0 131.5-58.898 131.5-131.5s-58.9-131.5-131.5-131.5zm0 216.8c-47.098 0-85.302-38.198-85.302-85.3s38.204-85.3 85.301-85.3c47.102 0 85.301 38.198 85.301 85.3s-38.2 85.3-85.3 85.3zM423.852 119.3c0 16.954-13.747 30.7-30.704 30.7-16.953 0-30.699-13.746-30.699-30.7 0-16.956 13.746-30.698 30.7-30.698 16.956 0 30.703 13.742 30.703 30.699zm0 0"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "logoeg2023",
    viewBox: "0 0 228 66"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M227.777 44.996c.176-1.098.024-1.285-1.054-1.324-1.078-.04-3.086.074-4.184.144-1.098.07-1.289.102-1.344.2-.054.093.028.261.145.441.117.176 2.531 3.871 3.613 5.387.66.945.906 2.035 1.809-.73.343-1.016.843-3.02 1.015-4.118"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#80bce0",
      fillOpacity: 1
    },
    d: "M199.371 33.992c1.274-1.433-3.125-.992-4.156-.996-.781.074-.781.188-.844.89-.07 1.005-.035 2.903.055 3.876.086.976.203 1.011.926.304.722-.707 3.351-3.265 4.02-4.074"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0079c2",
      fillOpacity: 1
    },
    d: "M200.5 42.852c-1.305 1.468 3.195 1.015 4.25 1.02.8-.075.797-.196.863-.915.075-1.023.035-2.969-.054-3.96-.09-.997-.207-1.036-.95-.313-.738.722-3.425 3.34-4.109 4.168"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#669dcc",
      fillOpacity: 1
    },
    d: "M210.406 44.523c1.266-1.421-3.09-.984-4.11-.984-.773.07-.773.184-.835.883-.07.992-.035 2.871.05 3.832.09.965.204 1.004.919.3.718-.695 3.316-3.23 3.976-4.03"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a6db2",
      fillOpacity: 1
    },
    d: "M199.68 53.016c1.507 1.343 1.039-3.29 1.043-4.375-.075-.825-.2-.825-.938-.891-1.05-.074-3.047-.04-4.066.055-1.024.09-1.063.215-.32.976.742.762 3.433 3.528 4.28 4.235"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4d8dc3",
      fillOpacity: 1
    },
    d: "M211.152 35.168c-1.304-1.219-.957 3.145-.972 4.168.054.777.16.77.808.812.926.036 2.68-.07 3.582-.187.903-.121.938-.238.293-.934-.64-.695-2.972-3.218-3.71-3.859"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M195.035 46.465c.063 1.89 3.035-1.574 3.805-2.317.531-.613.45-.691 0-1.214-.653-.73-2.024-1.996-2.778-2.594-.753-.602-.867-.54-.906.457-.043 1.004-.191 4.637-.12 5.668"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#80bce0",
      fillOpacity: 1
    },
    d: "M215.516 40.984c-.121-1.914-2.868 1.489-3.586 2.211-.496.602-.414.684.035 1.227.652.762 2.012 2.082 2.758 2.71.742.63.851.575.859-.437.008-1.008.035-4.672-.066-5.71"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a6db2",
      fillOpacity: 1
    },
    d: "M201.938 33.246c-2.032.066 1.425 3.043 2.152 3.816.61.536.703.45 1.3-.003.837-.66 2.305-2.04 3.008-2.797.707-.758.653-.875-.414-.91-1.066-.04-4.941-.184-6.047-.106"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M208.707 54.266c2.328-.153-1.805-3.48-2.676-4.352-.73-.598-.828-.496-1.492.05-.926.802-2.539 2.458-3.309 3.364-.77.906-.703 1.04.528 1.043 1.226.004 5.68.024 6.949-.105"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4da1d4",
      fillOpacity: 1
    },
    d: "M208.355 33.074c1.985-.039-1.449-3.078-2.175-3.863-.606-.543-.692-.461-1.27-.016-.808.653-2.219 2.02-2.894 2.774-.676.754-.625.87.422.922 1.046.054 4.835.246 5.917.183"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M195.543 38.496c-.582.758 2.664 3.238 3.344 3.883.675.613.773.516 1.425-.008.91-.766 2.504-2.36 3.27-3.238.156-.18.719-.863.766-.93.382-.441-2.711-3.098-3.309-3.777-.664-.621-.762-.528-1.422-.016-.922.75-2.539 2.324-3.316 3.192-.395.437-.617.671-.758.894"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#66aeda",
      fillOpacity: 1
    },
    d: "M215.05 48.742c.583-.773-2.523-3.199-3.171-3.836-.645-.601-.742-.504-1.383.035-.898.782-2.476 2.41-3.23 3.305-.157.184-.715.879-.762.945-.379.45 2.574 3.059 3.14 3.727.637.613.735.516 1.383-.012.91-.77 2.504-2.37 3.274-3.254.39-.449.61-.683.75-.91"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3394ce",
      fillOpacity: 1
    },
    d: "M210.742 34.063c-1.39-1.598 3.145-.977 4.2-.946.804.102.812.227.917.992.133 1.09.207 3.145.176 4.2-.031 1.054-.148 1.09-.933.3-.782-.789-3.625-3.652-4.36-4.547"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M215.918 46.668c.07 1.918 2.941-1.45 3.687-2.164.516-.594.434-.676-.003-1.23-.641-.774-1.977-2.118-2.715-2.758-.735-.645-.844-.59-.88.422-.034 1.011-.163 4.68-.089 5.73"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M211 53.406c-1.977 1.668 3.102 1.063 4.133 1.09.785-.05.785-.168.863-.871.098-1 .106-2.902.04-3.875-.067-.977-.18-1.016-.923-.324-.738.687-3.425 3.187-4.113 3.98"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4da1d4",
      fillOpacity: 1
    },
    d: "M202.328 54.867c-1.894.153 1.828 2.797 2.531 3.48.59.465.668.383 1.211-.062.762-.648 2.09-1.988 2.723-2.722.633-.731.578-.836-.418-.82-1 .01-5.016.003-6.047.124M195.324 49.34c-1.441-1.266-.965 3.14-.957 4.172.082.789.196.781.899.84 1 .062 2.89.007 3.863-.086.973-.098 1.008-.215.297-.934-.711-.719-3.29-3.328-4.102-3.992"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#66aeda",
      fillOpacity: 1
    },
    d: "M194.707 40.387c-.07-1.953-3.191 1.726-4.004 2.52-.562.648-.473.726.004 1.253.691.735 1.895 1.856 2.676 2.75.715.844 1.289 1.555 1.258-.969.043-1.039.144-4.492.066-5.554"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M222 28.875c-.676-.879-.914-.898-1.688-.14-.765.757-2.066 2.292-2.769 3.14-.707.848-.82 1.008-.785 1.113.031.11.21.16.422.2.207.039 4.543.824 6.382 1.082 1.141.167 2.098.738.72-1.82-.497-.95-1.606-2.692-2.282-3.575"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3394ce",
      fillOpacity: 1
    },
    d: "M220.008 26.793c.902.648.93.887.199 1.687-.727.793-2.215 2.149-3.035 2.887-.817.735-.973.852-1.082.824-.106-.027-.164-.203-.211-.414-.043-.207-.98-4.523-1.305-6.359-.207-1.137-.808-2.074 1.79-.785.964.469 2.741 1.515 3.644 2.16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M203.68 21.625c1.097-.152 1.285 0 1.297 1.082.015 1.082-.137 3.094-.23 4.191-.095 1.102-.126 1.293-.224 1.344-.097.055-.261-.035-.437-.156s-3.813-2.617-5.3-3.73c-.93-.684-2.009-.954.765-1.801 1.02-.325 3.031-.782 4.129-.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a86c8",
      fillOpacity: 1
    },
    d: "M188.113 29.145c.653-.899.89-.922 1.68-.188.789.738 2.129 2.242 2.855 3.07.727.828.844.985.813 1.094-.031.106-.207.164-.418.207-.207.04-4.52.942-6.352 1.25-1.136.195-2.078.793-.765-1.8.472-.965 1.535-2.735 2.187-3.633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#80bce0",
      fillOpacity: 1
    },
    d: "M206.688 21.477c-1.09-.188-1.282-.04-1.333 1.039-.05 1.082.04 3.093.094 4.195.059 1.105.086 1.297.184 1.352.094.058.262-.024.437-.141.18-.113 3.895-2.492 5.422-3.555.95-.652 2.04-.887-.707-1.824-1.012-.36-3.004-.879-4.097-1.066"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a6db2",
      fillOpacity: 1
    },
    d: "M190.441 26.926c-.894.66-.921.902-.183 1.691.738.79 2.242 2.121 3.07 2.848.828.726.984.844 1.09.812.11-.03.168-.207.207-.418.043-.207.926-4.535 1.227-6.37.195-1.141.789-2.09-1.797-.766-.957.48-2.72 1.55-3.614 2.203"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#80bce0",
      fillOpacity: 1
    },
    d: "M182.578 42.129c-.148 1.101.004 1.285 1.082 1.305 1.082.015 3.082-.141 4.18-.235 1.097-.09 1.289-.12 1.34-.222.054-.098-.032-.262-.153-.438-.12-.176-2.609-3.82-3.722-5.316-.68-.93-.946-2.016-1.793.765-.325 1.024-.782 3.04-.934 4.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0079c2",
      fillOpacity: 1
    },
    d: "M188.422 58.46c.68.88.922.9 1.687.142.766-.766 2.059-2.305 2.758-3.157.703-.851.813-1.011.778-1.117-.032-.105-.208-.16-.418-.195-.207-.035-4.551-.805-6.391-1.055-1.14-.164-2.102-.73-.711 1.824.504.946 1.617 2.68 2.297 3.559"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M182.621 45.254c-.184-1.137-.027-1.336 1.094-1.379 1.117-.047 3.2.063 4.34.129 1.14.066 1.34.098 1.398.195.055.102-.031.278-.152.461-.117.184-2.61 4.031-3.719 5.613-.684.98-.934 2.118-1.887-.75-.36-1.05-.886-3.132-1.074-4.27M190.633 60.824c-.965-.633-1.004-.883-.281-1.738.722-.86 2.023-2.652 2.843-3.45.82-.796.848-.866.961-.84.11.028.492.47.547.688.059.211 1.207 4.649 1.621 6.54.262 1.167.926 2.117-1.824.89-1.02-.445-2.906-1.46-3.867-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4da1d4",
      fillOpacity: 1
    },
    d: "M207.117 66.074c-1.129.219-1.328.07-1.414-1.05-.078-1.122-.035-3.208-.004-4.352.031-1.149.051-1.348.153-1.406.097-.063.273.02.46.132.188.114 4.106 2.489 5.715 3.551 1.004.653 2.141.867-.687 1.91-1.04.399-3.094.993-4.223 1.215"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M222.473 58.273c-.641.961-.887.997-1.739.266-.847-.734-2.297-2.238-3.082-3.066-.793-.828-.918-.985-.89-1.098.027-.113.207-.18.422-.234.214-.051 4.652-1.164 6.539-1.559 1.168-.254 2.125-.91.87 1.836-.452 1.016-1.484 2.898-2.12 3.855"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a86c8",
      fillOpacity: 1
    },
    d: "M227.797 41.879c.191 1.137.039 1.332-1.082 1.39-1.117.055-3.203-.039-4.34-.097-1.145-.059-1.344-.082-1.398-.184-.063-.097.023-.273.144-.46.117-.188 2.574-4.051 3.676-5.641.672-.992.914-2.125 1.887.73.37 1.051.918 3.125 1.113 4.262"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4d8dc3",
      fillOpacity: 1
    },
    d: "M203.867 65.969c1.098.164 1.285.015 1.317-1.067.03-1.082-.098-3.09-.176-4.191-.078-1.102-.106-1.297-.203-1.348-.098-.054-.262.028-.442.149-.175.117-3.843 2.566-5.347 3.66-.942.668-2.028.922.738 1.808 1.016.336 3.02.825 4.113.989"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a86c8",
      fillOpacity: 1
    },
    d: "M219.973 60.441c.89-.664.918-.902.175-1.691-.742-.785-1.902-2.29-2.73-3.012-.832-.722-1.336-.668-1.441-.636-.106.03-.165.207-.207.418-.04.207-.91 4.539-1.208 6.378-.19 1.137-.78 2.086 1.801.758.957-.48 2.715-1.558 3.61-2.215M200.672 32.387c.578-.18 4.062-3.157 3.473-3.664-.758-.68-6.778-5.133-7.278-5.13-.273.052-1.308 5.704-1.867 8.403-.227.836 3.742.672 5.2.488.21-.03.394-.07.472-.097"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M206.715 58.621c.722.625 6.441 4.746 6.91 4.742.258-.054 1.16-5.36 1.656-7.894.203-.782-3.453-.582-4.898-.407-.582.067-4.227 3.086-3.668 3.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#80bce0",
      fillOpacity: 1
    },
    d: "M200.145 54.852c-.547-.25-4.965-.313-4.864.453.121 1.004 1.668 8.277 2.04 8.601.238.145 4.706-3.367 6.89-5 .719-.468-2.106-2.515-3.152-3.582-.145-.148-.836-.445-.914-.472"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4d8dc3",
      fillOpacity: 1
    },
    d: "M193.875 48.45c-.188-.579-3.434-4.536-3.93-3.938-.66.77-4.968 7.058-4.957 7.558.055.274 5.711 1.207 8.414 1.723.836.21.504-5.266.473-5.344M216.66 39.445c.188.582 3.219 3.692 3.715 3.094.66-.773 4.996-6.89 4.984-7.39-.054-.274-5.71-1.208-8.414-1.72-.836-.214-.66 3.66-.449 5.118.031.207.133.824.164.898"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M210.3 32.629c.528.266 4.919.105 4.966-.441-.07-.985-1.25-8.176-1.602-8.512-.226-.149-4.8 3.117-7.031 4.633-.73.43 1.855 2.91 2.933 3.968.145.145.66.32.735.352"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M193.93 38.785c.25-.543.3-5.144-.457-5.05-.993.109-8.196 1.578-8.52 1.94-.144.24 3.3 4.731 4.902 6.927.461.718 2.903-2.02 3.727-3.211.117-.168.316-.532.348-.606"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4da1d4",
      fillOpacity: 1
    },
    d: "M216.695 48.36c-.246.55-.37 5.628.395 5.511 1.004-.137 8.078-1.988 8.402-2.363.145-.242-3.176-4.461-4.82-6.61-.469-.703-2.621 1.438-3.442 2.653-.12.176-.503.73-.535.808"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005ca9",
      fillOpacity: 1
    },
    d: "M210.773 40.523c-.671.036-.75.114-.59.579.16.464.555 1.316.813 1.742.254.422.363.406.86 0a19.975 19.975 0 0 0 1.761-1.735c.41-.472.38-.547-.27-.582a31.414 31.414 0 0 0-2.574-.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#66aeda",
      fillOpacity: 1
    },
    d: "M199.2 44.332c.687-.555.831-.55 1.085.023.254.57.617 1.715.738 2.333.13.62.008.703-.835.757-.844.055-2.438.016-3.258-.062-.817-.082-.848-.18-.246-.781a42.647 42.647 0 0 1 2.515-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0079c2",
      fillOpacity: 1
    },
    d: "M204.934 48.465c-.07.758-.16.844-.66.656a12.332 12.332 0 0 1-1.876-.934c-.453-.292-.43-.417.04-.968.468-.551 1.445-1.512 1.98-1.969.539-.457.613-.418.625.313.012.73-.04 2.152-.11 2.902"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a6db2",
      fillOpacity: 1
    },
    d: "M202.277 46.695c-.539.438-.652.438-.855-.011a11.442 11.442 0 0 1-.594-1.836c-.101-.489-.008-.551.66-.598.66-.047 1.918-.023 2.563.031.644.059.668.137.199.614a33.63 33.63 0 0 1-1.973 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M209.777 43.262c.754-.043.844-.13.68-.64a12.34 12.34 0 0 0-.871-1.911c-.274-.465-.399-.445-.965.004-.566.45-1.555 1.394-2.031 1.914-.477.52-.438.601.289.637.726.039 2.144.039 2.898-.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3394ce",
      fillOpacity: 1
    },
    d: "M208.398 40.246c.48-.504.489-.621.055-.855-.43-.239-1.3-.598-1.777-.739-.477-.14-.551-.047-.649.61-.097.66-.172 1.918-.164 2.566.008.649.082.68.594.246a33.986 33.986 0 0 0 1.941-1.828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#337dba",
      fillOpacity: 1
    },
    d: "M203.84 50.14c.527-.538.531-.663.047-.925-.48-.262-1.453-.66-1.989-.817-.53-.156-.609-.062-.707.653-.097.71-.16 2.07-.14 2.773.02.7.105.735.664.27a34.164 34.164 0 0 0 2.125-1.953"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#80bce0",
      fillOpacity: 1
    },
    d: "M206.406 36.773c-.71.73-.734.895-.168 1.247.559.351 1.707.882 2.344 1.09.637.206.746.078.953-.883.203-.957.442-2.79.504-3.73.059-.95-.039-.993-.781-.368a51.374 51.374 0 0 0-2.852 2.644"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#4565ad",
      fillOpacity: 1
    },
    d: "M128.004 51.262c-3.367-.012-6.078-2.801-6.02-6.18.063-3.32 2.778-5.934 6.145-5.906 3.316.031 6.031 2.8 5.969 6.094-.067 3.343-2.766 6.003-6.094 5.992m.047-18.293a12.187 12.187 0 0 0-12.223 12.191c-.008 6.824 5.484 12.34 12.254 12.309 6.75-.035 12.148-5.489 12.145-12.278-.004-6.785-5.418-12.222-12.176-12.222"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#0c2f6a",
      fillOpacity: 1
    },
    d: "M61.445 47.813h11.043v-4.758H61.473v-4.383h12.465v-5.008H55.492v23.684h18.602v-5.059H61.445ZM97.46 43.93h-9.78v3.957h3.632c.141 2.699-.417 3.425-2.757 3.773-2.77.414-5.36-.86-6.582-3.242-1.332-2.598-.895-5.89 1.054-7.89 1.918-1.97 4.82-2.52 7.336-1.239 1.078.55 2.02 1.383 3.117 2.152l3.524-3.812c-2.559-3.55-6.84-5.18-11.578-4.5-6.649.957-11.485 7.687-10.14 14.21 1.015 4.923 3.968 8.188 8.773 9.567 4.89 1.403 9.171.082 12.812-3.414.258-.246.559-.605.563-.922.043-2.863.027-5.726.027-8.64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fdc300",
      fillOpacity: 1
    },
    d: "M155.633 33.664v4.156s3.441.063 3.773 1.88c0 0 .395 1.882-1.886 2.698l.011 3.633s3 .504 2.801 3.387c0 0-.332 2.828-4.7 2.637v5.277s7.079.55 9.598-5.09c0 0 2.18-5.332-2.714-8.906 0 0 1.722-2.133 1.058-5.016 0 0-1.015-4.668-6.992-4.652-.3 0-.625-.004-.95-.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#a5c715",
      fillOpacity: 1
    },
    d: "M152.969 57.348v-5.625l-10.078 5.625Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#009fe3",
      fillOpacity: 1
    },
    d: "M152.246 45.984c1.04-2.254.902-5.218-.059-7.168-.003-.004-.003-.004-.003-.007-1.004-2.29-3.352-5.176-8.688-5.145h-.605v5.02s3.605.066 4.058 3.554c0 0 .203 3.102-4.058 4.27v6.36s5.152-2.548 7.863-4.876a5.65 5.65 0 0 0 1.152-1.367s.317-.594.34-.64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#e5007d",
      fillOpacity: 1
    },
    d: "M113.16 57.348v-5.625l-10.074 5.625ZM112.441 45.984c1.04-2.254.899-5.218-.058-7.168-.004-.004-.004-.004-.004-.007-1.004-2.29-3.352-5.176-8.688-5.145h-.605v5.02s3.605.066 4.059 3.554c0 0 .203 3.102-4.06 4.27v6.36s5.153-2.548 7.864-4.876a5.74 5.74 0 0 0 1.153-1.367l.34-.64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0c2f6a",
      fillOpacity: 1
    },
    d: "M86.883 64.305h1.879v-.985h-1.88v-.758h2.102v-.988h-3.293v4.52h3.336v-.989h-2.144ZM92.723 64.402c0 .457-.356.762-.871.762-.54 0-.891-.305-.891-.762v-2.828h-1.195v3.047c0 .922.828 1.531 2.074 1.531s2.074-.609 2.074-1.53v-3.048h-1.191ZM98.555 63.148c0-.945-.707-1.574-1.754-1.574H94.84v4.52h1.191v-3.531h.645c.39 0 .64.28.64.714 0 .434-.222.72-.64.72-.164 0-.317-.013-.48-.06.581.715 1.14 1.52 1.452 2.157h1.368a15.3 15.3 0 0 0-1.07-1.68c.359-.266.609-.691.609-1.266M101.668 65.164c-.742 0-1.234-.531-1.234-1.332 0-.8.492-1.332 1.234-1.332.734 0 1.227.531 1.227 1.332 0 .8-.493 1.332-1.227 1.332m0-3.652c-1.48 0-2.465.93-2.465 2.32 0 1.395.984 2.32 2.465 2.32 1.469 0 2.457-.925 2.457-2.32 0-1.39-.988-2.32-2.457-2.32M106.703 63.82h-.668v-1.258h.668c.344 0 .555.25.555.622 0 .386-.211.636-.555.636m.121-2.246h-1.984v4.52h1.195v-1.285h.73c1.04 0 1.731-.664 1.731-1.66 0-.946-.672-1.575-1.672-1.575M110.32 64.305h1.875v-.985h-1.875v-.758h2.102v-.988h-3.297v4.52h3.34v-.989h-2.145ZM114.602 64.535c.168-.336.347-.68.52-1.012.171.332.355.676.519 1.012Zm.488-3.023c-.785 1.343-1.668 3.054-2.426 4.582h1.273c.086-.192.172-.38.266-.574h1.84c.09.195.176.382.258.574h1.273c-.754-1.528-1.644-3.239-2.422-4.582ZM121.277 63.98l-.629-.527c-1.058-.894-2.289-1.941-2.691-1.941v4.582h1.195l-.02-2.403.665.559c1.055.883 2.254 1.902 2.656 1.902v-4.578h-1.195ZM127.012 64.04h1.203v1.507c-.32.094-.684.148-.942.148-1.144 0-1.757-.757-1.757-1.843 0-1.141.699-1.883 1.796-1.883.348 0 .883.093 1.235.234v-.433a4.36 4.36 0 0 0-1.395-.258c-1.304 0-2.21.922-2.21 2.34 0 1.332.796 2.3 2.21 2.3.328 0 .727-.066 1.075-.175a.97.97 0 0 0 .539.144v-2.539h-1.754ZM130.438 64.547c.316-.727.652-1.445.976-2.102.32.657.664 1.375.973 2.102Zm.953-3.035a51.372 51.372 0 0 0-2.172 4.582h.594c.132-.356.277-.723.43-1.09h2.339c.16.367.305.734.438 1.09h.593a53.632 53.632 0 0 0-2.168-4.582ZM136.7 64.719c-.66-1.012-2.106-3.207-2.427-3.207v4.582h.555l-.023-3.305c.547.695 1.422 2.05 1.875 2.785h.043c.445-.726 1.328-2.082 1.87-2.785l-.015 3.305h.543v-4.582c-.32 0-1.758 2.195-2.422 3.207M140.945 64.016h2.13v-.457h-2.13V62.03h2.285v-.457h-2.84v4.52h2.895v-.461h-2.34ZM145.766 63.492l-.262-.062c-.512-.121-.938-.246-.938-.727 0-.476.38-.746 1.098-.746.367 0 .805.094 1.242.25v-.418a3.612 3.612 0 0 0-1.36-.277c-.968 0-1.538.453-1.538 1.281 0 .789.527 1.02 1.222 1.18l.262.062c.63.145 1.074.367 1.074.88 0 .495-.398.792-1.132.792-.375 0-.825-.09-1.262-.297v.418c.36.215.957.324 1.414.324.953 0 1.527-.488 1.527-1.3 0-.872-.578-1.184-1.347-1.36M76.39 64.086v-.012c.227-.066.407-.168.547-.316.141-.145.211-.336.211-.582a.83.83 0 0 0-.164-.524c-.109-.14-.25-.254-.418-.343a1.93 1.93 0 0 0-.554-.184c-.2-.04-.395-.059-.578-.059-.262 0-.493.012-.7.032-.203.02-.406.062-.601.12v.887a3.296 3.296 0 0 1 .957-.152c.066 0 .133.004.203.016a.567.567 0 0 1 .184.062c.058.032.105.07.136.121.035.051.051.118.051.196 0 .082-.027.148-.082.191a.514.514 0 0 1-.207.102c-.078.02-.16.03-.246.035-.086.004-.16.008-.223.008-.05 0-.105-.004-.156-.004-.055-.004-.105-.004-.16-.008v.867c.082-.012.164-.02.242-.027a2.005 2.005 0 0 1 .453 0 .879.879 0 0 1 .211.054.437.437 0 0 1 .16.118c.043.05.067.117.067.199 0 .078-.02.14-.051.187a.308.308 0 0 1-.137.106.622.622 0 0 1-.2.05c-.077.012-.16.016-.245.016a3.219 3.219 0 0 1-.996-.164v.918c.09.027.187.05.3.07a2.9 2.9 0 0 0 .344.051c.121.016.242.024.367.031.125.008.243.012.356.012.203 0 .41-.02.617-.062.207-.043.395-.106.563-.2.168-.09.304-.207.406-.355a.91.91 0 0 0 .156-.543c0-.258-.074-.46-.226-.605a1.32 1.32 0 0 0-.586-.31M82.121 65.18c-.176.086-.34.129-.5.129a.601.601 0 0 1-.48-.207c-.118-.141-.176-.329-.176-.563 0-.23.066-.418.2-.559a.691.691 0 0 1 .526-.21c.125 0 .27.039.43.117Zm0-2.094a1.664 1.664 0 0 0-.695-.156c-.473 0-.852.148-1.137.445-.289.297-.434.688-.434 1.168 0 .484.137.875.41 1.168.274.293.633.437 1.079.437.34 0 .652-.078.941-.23.254.14.559.207.91.207v-4.527l-1.074.308ZM77.664 62.95v3.144h1.074v-2.028c.239-.082.535-.125.883-.125V62.93c-.348 0-.683.082-1.004.25a1.892 1.892 0 0 0-.953-.23M103.09 29.777h.687v-5.05l2.27 3.335h.035l2.27-3.343v5.058h.703v-6.246h-.711l-2.27 3.407-2.27-3.407h-.714Zm6.972 0h.72l.741-1.652h3.391l.727 1.652h.757l-2.84-6.293h-.656Zm1.735-2.285 1.426-3.183 1.414 3.183Zm8.152-1.293v-.687l-1.574.742V23.53h-.703v3.043l-.668.313v.687l.668-.312v2.515h4.21v-.652h-3.507v-2.188Zm5.547 3.684c1.899 0 3.188-1.508 3.188-3.23v-.016c0-1.723-1.274-3.215-3.168-3.215-1.895 0-3.188 1.508-3.188 3.23v.02c0 1.723 1.274 3.21 3.168 3.21m.02-.648c-1.426 0-2.457-1.16-2.457-2.582v-.015c0-1.418 1.011-2.563 2.437-2.563s2.457 1.16 2.457 2.578v.02c0 1.418-1.016 2.562-2.437 2.562m4.433.543h.7v-2.203h1.515c1.328 0 2.45-.695 2.45-2.047v-.015c0-1.235-.927-1.98-2.333-1.98h-2.332Zm.7-2.847v-2.746h1.578c1.003 0 1.671.46 1.671 1.355v.016c0 .824-.675 1.375-1.707 1.375Zm7.913 2.953c1.899 0 3.188-1.508 3.188-3.23v-.016c0-1.723-1.27-3.215-3.168-3.215-1.894 0-3.187 1.508-3.187 3.23v.02c0 1.723 1.273 3.21 3.167 3.21m.02-.648c-1.426 0-2.457-1.16-2.457-2.582v-.015c0-1.418 1.016-2.563 2.438-2.563 1.425 0 2.457 1.16 2.457 2.578v.02c0 1.418-1.012 2.562-2.438 2.562m4.434.543h4.21v-.652h-3.507v-5.594h-.703Zm7.422.09c1.238 0 2.128-.695 2.128-1.77v-.015c0-.957-.64-1.465-2.03-1.77-1.368-.292-1.692-.625-1.692-1.21v-.02c0-.562.52-1.008 1.328-1.008.64 0 1.219.203 1.797.68l.41-.547c-.633-.508-1.281-.766-2.191-.766-1.184 0-2.043.723-2.043 1.704v.02c0 1.023.656 1.487 2.09 1.8 1.308.277 1.62.61 1.62 1.187v.016c0 .617-.55 1.066-1.39 1.066-.863 0-1.485-.297-2.137-.886l-.433.52c.746.667 1.554 1 2.542 1m3.34-.09h.703v-1.68l1.329-1.344 2.39 3.023h.883l-2.785-3.515 2.668-2.73h-.906l-3.579 3.73v-3.73h-.703Zm5.598 0h.723l.738-1.653h3.39l.731 1.652h.758l-2.84-6.293h-.66Zm1.738-2.286 1.422-3.183 1.418 3.183ZM59.32 29.773c-.62-.98-1.32-1.87-2.18-2.875v2.875h-1.648v-6.242h1.649v2.707c.785-.945 1.457-1.812 2.023-2.707h1.867a30.703 30.703 0 0 1-2.297 3.028c1.094 1.199 1.707 2.125 2.45 3.214ZM64.727 27.89h.007Zm2.828 1.883H65.66c-.43-.878-1.207-1.992-2.004-2.976.227.066.438.082.664.082.575 0 .883-.395.883-.996 0-.598-.344-.988-.883-.988h-.89v4.878h-1.653v-6.246h2.711c1.45 0 2.426.871 2.426 2.18 0 .793-.348 1.383-.844 1.746.422.582 1.02 1.461 1.485 2.32M70.254 27.621h1.441c-.238-.473-.492-.933-.726-1.398-.235.453-.48.925-.715 1.398m1.988 1.36H69.7l-.363.792h-1.758c1.043-2.109 2.266-4.472 3.348-6.328h.086c1.078 1.856 2.304 4.22 3.347 6.328h-1.757ZM78.71 29.773c-.62-.98-1.32-1.87-2.179-2.875v2.875h-1.648v-6.242h1.648v2.707c.785-.945 1.457-1.812 2.02-2.707h1.87a30.174 30.174 0 0 1-2.3 3.028c1.098 1.199 1.711 2.125 2.45 3.214Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0c2f6a",
      fillOpacity: 1
    },
    d: "m83.156 22.71 1.051.298 1.5-1.285-1.422-.403Zm2.371 3.942c0-1.105-.68-1.84-1.691-1.84-1.023 0-1.707.735-1.707 1.84 0 1.106.683 1.84 1.707 1.84 1.012 0 1.691-.734 1.691-1.84m-5.097 0c0-1.925 1.363-3.207 3.406-3.207 2.031 0 3.394 1.282 3.394 3.207 0 1.922-1.363 3.207-3.394 3.207-2.043 0-3.406-1.285-3.406-3.207M97.465 23.531c-.918 2.11-1.996 4.469-2.95 6.328h-.081a89.713 89.713 0 0 1-2.063-3.875 81.02 81.02 0 0 1-2.098 3.875H90.2c-.941-1.859-2.004-4.218-2.922-6.328h1.762c.418 1.012.875 2.082 1.336 3.121.523-1.039 1.027-2.109 1.5-3.12h.992c.461 1.011.977 2.081 1.508 3.12.453-1.039.91-2.109 1.32-3.12Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdc300",
      fillOpacity: 1
    },
    d: "M30.004 10.3c-.16-.933-.602-2.792-.602-2.792l-6.382 3.394-.696.446c-.367.234-.68.539-.918.902-.172.254-.343.508-.523.754-1.688 2.312-2.48 3.043-4.992 5.285l13.691-7.129a.767.767 0 0 0 .422-.86"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#009fe3",
      fillOpacity: 1
    },
    d: "m29.004 22.41 1.082-3.953-.23-.18C24.378 21.645 11.975 29.657 0 37.41l.133.235c7.719-4.06 17.726-9.254 28.57-14.86a.602.602 0 0 0 .3-.375"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4565ad",
      fillOpacity: 1
    },
    d: "M10.953 15.414c-.332-.879-3.89-4.195-5.594-5.086l.895 7.485Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdc300",
      fillOpacity: 1
    },
    d: "m12.559 17.668-6.082 3.844c-.38.238-.66.61-.782 1.039l-.363 1.273 8.41-4.344Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e5007d",
      fillOpacity: 1
    },
    d: "M30.266 16.016c.027-.493.043-.989.043-1.489 0-.609.043-1.347 0-1.949 0 0-2.536 1.317-5.188 2.902C22.47 17.066 3.316 29.418 3.316 29.418a2.034 2.034 0 0 0-.648.738c-.008.016-.016.032-.027.047-.125.254-.164.414-.262.695l27.46-14.222a.788.788 0 0 0 .427-.66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0c2f6a",
      fillOpacity: 1
    },
    d: "m29.777 33.348 5.246-2.684a113.67 113.67 0 0 1-1.64-2.969s-2.91 1.86-3.367 2.157c-.453.3-.414.53-.414.847 0 .223.175 2.649.175 2.649M32.86 26.18l-.563-3.242c-1.008 1.453-1.781 2.859-2.277 4.507l.175.133ZM32.047 37.754l6.762-3.496c-.957-.793-1.891-1.61-2.809-2.383l-5.418 3.5ZM28.992 66.05c6.074-1.179 11.68-4.679 15.281-10.112l-15.378 9.96ZM47.379 48.07 19.684 65.934l.082.226c.363-.07.718-.11.957-.234L45.074 53.3c.528-.278 1.25-.938 1.492-1.48.989-2.184.813-3.75.813-3.75M33.145 39.996c.09.313.609 2.445.609 2.445l1.086-.562 8.504-4.418c-.895-.77-2.457-1.762-3.258-2.29l-6.758 4.337c-.137.09-.23.332-.183.488M33.902 44.941c-.316.204-.554.5-.687.848-.168.43-.348.863-.555 1.293-.277.637-.582 1.332-.836 1.922l6.27-3.254 7.648-3.977a.43.43 0 0 0 .192-.562 14.311 14.311 0 0 0-1.786-2.84L36.23 43.45ZM15.094 45.352 6.69 50.73c.024.06.047.114.075.172l8.648-4.5ZM17.484 49.691l-8.597 5.493.078.14 9.36-4.863ZM25.008 52.547a9.124 9.124 0 0 1-2.645-.148l-1.836 1.18-9.183 5.886c.027.047.054.094.086.14l9.652-5.02ZM47.238 46.102c-.047-.582-.113-1.016-.113-1.016a13.577 13.577 0 0 0-.59-2.387L14.078 63.656c.04.051.04.04.074.09l32.739-17.008a.652.652 0 0 0 .347-.636M15.191 40.316a3.03 3.03 0 0 0 .286-1.078L4.16 46.504a.872.872 0 0 0 .508-.086l9.355-4.844c.524-.27.934-.715 1.168-1.258M24.785 29.996c1.047-1.215 1.969-2.672 2.824-4.46L1.406 42.413c.16 0 .39-.062.535-.137l21.395-11.101a4.974 4.974 0 0 0 1.45-1.18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4565ad",
      fillOpacity: 1
    },
    d: "M25.504 0c-.137 2.684-1.305 6.559-2.274 8.992l5.688-3.07Zm0 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logoeg2023_inv",
    viewBox: "0 0 228 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 51.3c-3.4 0-6.1-2.8-6-6.2.1-3.3 2.8-5.9 6.1-5.9s6 2.8 6 6.1c-.1 3.3-2.8 6-6.1 6m.1-18.3c-6.8 0-12.2 5.4-12.2 12.2 0 6.8 5.5 12.3 12.3 12.3 6.8 0 12.1-5.5 12.1-12.3-.1-6.8-5.5-12.2-12.2-12.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4565ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    },
    d: "M61.4 47.8h11V43h-11v-4.4h12.5v-5H55.5v23.7h18.6v-5.1H61.4v-4.4zM97.5 43.9h-9.8v4h3.6c.1 2.7-.4 3.4-2.8 3.8-2.8.4-5.4-.9-6.6-3.2-1.3-2.6-.9-5.9 1.1-7.9 1.9-2 4.8-2.5 7.3-1.2 1.1.6 2 1.4 3.1 2.2 1.1-1.2 2.3-2.5 3.5-3.8-2.6-3.6-6.8-5.2-11.6-4.5-6.6 1-11.5 7.7-10.1 14.2 1 4.9 4 8.2 8.8 9.6 4.9 1.4 9.2.1 12.8-3.4.3-.2.6-.6.6-.9.1-3.1.1-6 .1-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6 33.7v4.2s3.4.1 3.8 1.9c0 0 .4 1.9-1.9 2.7v3.6s3 .5 2.8 3.4c0 0-.3 2.8-4.7 2.6v5.3s7.1.6 9.6-5.1c0 0 2.2-5.3-2.7-8.9 0 0 1.7-2.1 1.1-5 0 0-1-4.7-7-4.7h-1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fdc300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 57.3v-5.6l-10.1 5.6H153z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a5c715"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 46c1-2.3.9-5.2-.1-7.2-1-2.3-3.4-5.2-8.7-5.1h-.6v5s3.6.1 4.1 3.6c0 0 .2 3.1-4.1 4.3V53s5.2-2.5 7.9-4.9c.5-.4.9-.9 1.2-1.4 0-.1.3-.7.3-.7",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009fe3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e5007d"
    },
    d: "M113.2 57.3v-5.6l-10.1 5.6h10.1zM112.4 46c1-2.3.9-5.2-.1-7.2-1-2.3-3.4-5.2-8.7-5.1h-.6v5s3.6.1 4.1 3.6c0 0 .2 3.1-4.1 4.3V53s5.2-2.5 7.9-4.9c.5-.4.9-.9 1.2-1.4 0-.1.3-.7.3-.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M86.9 64.3h1.9v-1h-1.9v-.8H89v-1h-3.3V66H89v-1h-2.1v-.7zM92.7 64.4c0 .5-.4.8-.9.8s-.9-.3-.9-.8v-2.8h-1.2v3c0 .9.8 1.5 2.1 1.5s2.1-.6 2.1-1.5v-3h-1.2v2.8zM98.6 63.1c0-.9-.7-1.6-1.8-1.6h-2V66H96v-3.5h.6c.4 0 .6.3.6.7s-.1.8-.5.8c-.2 0-.3 0-.5-.1.6.7 1.1 1.5 1.5 2.2H99c-.3-.6-.8-1.3-1.1-1.7.4-.3.7-.7.7-1.3M101.7 65.2c-.7 0-1.2-.5-1.2-1.3s.5-1.3 1.2-1.3 1.2.5 1.2 1.3-.5 1.3-1.2 1.3m0-3.7c-1.5 0-2.5.9-2.5 2.3s1 2.3 2.5 2.3 2.5-.9 2.5-2.3c-.1-1.4-1.1-2.3-2.5-2.3M106.7 63.8h-.7v-1.3h.7c.3 0 .6.2.6.6 0 .5-.3.7-.6.7m.1-2.2h-2v4.5h1.2v-1.3h.7c1 0 1.7-.7 1.7-1.7.1-.9-.6-1.5-1.6-1.5M110.3 64.3h1.9v-1h-1.9v-.8h2.1v-1h-3.3V66h3.3v-1h-2.1v-.7zM114.6 64.5c.2-.3.3-.7.5-1 .2.3.4.7.5 1h-1zm.5-3c-.8 1.3-1.7 3.1-2.4 4.6h1.3l.3-.6h1.8l.3.6h1.3c-.9-1.5-1.8-3.2-2.6-4.6zM121.3 64l-.6-.5c-1.1-.9-2.3-1.9-2.7-1.9v4.6h1.2v-2.4l.7.6c1.1.9 2.3 1.9 2.7 1.9v-4.6h-1.2l-.1 2.3zM127 64h1.2v1.5c-.3.1-.7.1-.9.1-1.1 0-1.8-.8-1.8-1.8 0-1.1.7-1.9 1.8-1.9.3 0 .9.1 1.2.2v-.4c-.4-.2-1-.3-1.4-.3-1.3 0-2.2.9-2.2 2.3 0 1.3.8 2.3 2.2 2.3.3 0 .7-.1 1.1-.2.1.1.3.1.5.1v-2.5H127v.6zM130.4 64.5c.3-.7.7-1.4 1-2.1.3.7.7 1.4 1 2.1h-2zm1-3c-.7 1.3-1.5 3.1-2.2 4.6h.6c.1-.4.3-.7.4-1.1h2.3c.2.4.3.7.4 1.1h.6c-.5-1.5-1.3-3.2-2.1-4.6zM136.7 64.7c-.7-1-2.1-3.2-2.4-3.2v4.6h.6v-3.3c.5.7 1.4 2.1 1.9 2.8.4-.7 1.3-2.1 1.9-2.8v3.3h.5v-4.6c-.4 0-1.8 2.2-2.5 3.2M140.9 64h2.1v-.5h-2.1V62h2.3v-.5h-2.8V66h2.9v-.5H141V64zM145.8 63.5l-.3-.1c-.5-.1-.9-.2-.9-.7 0-.5.4-.7 1.1-.7.4 0 .8.1 1.2.2v-.4c-.5-.2-.9-.3-1.4-.3-1 0-1.5.5-1.5 1.3s.5 1 1.2 1.2l.3.1c.6.1 1.1.4 1.1.9s-.4.8-1.1.8c-.4 0-.8-.1-1.3-.3v.4c.4.2 1 .3 1.4.3 1 0 1.5-.5 1.5-1.3 0-.9-.6-1.2-1.3-1.4M76.4 64.1c.2-.1.4-.2.5-.3.1-.1.2-.3.2-.6 0-.2-.1-.4-.2-.5s-.2-.3-.4-.3c-.2-.1-.4-.1-.6-.2-.2 0-.4-.1-.6-.1h-.7c-.2 0-.4.1-.6.1v.9c.1 0 .3-.1.4-.1h.7c.1 0 .1 0 .2.1.1 0 .1.1.1.1 0 .1.1.1.1.2s0 .1-.1.2c-.1 0-.1.1-.2.1h-.8v.9H75c.1 0 .1 0 .2.1.1 0 .1.1.2.1s.1.1.1.2 0 .1-.1.2l-.1.1c-.1 0-.1 0-.2.1h-.2c-.2 0-.4 0-.6-.1-.2 0-.3-.1-.4-.1v.8c.1 0 .2.1.3.1.1 0 .2 0 .3.1h.8c.2 0 .4 0 .6-.1s.4-.1.6-.2c.2-.1.3-.2.4-.4.1-.1.2-.3.2-.5 0-.3-.1-.5-.2-.6-.1-.2-.3-.3-.5-.3M82.1 65.2c-.2.1-.3.1-.5.1s-.4-.1-.5-.2c-.1-.1-.1-.3-.1-.6 0-.2.1-.4.2-.6s.3-.2.5-.2c.1 0 .3 0 .4.1v1.4zm0-2.1c-.2-.1-.5-.2-.7-.2-.5 0-.9.1-1.1.4-.3.3-.4.7-.4 1.2s.1.9.4 1.2.6.4 1.1.4c.3 0 .7-.1.9-.2.3.1.6.2.9.2v-4.5l-1.1.3v1.2zM77.7 62.9V66h1.1v-2c.2-.1.5-.1.9-.1v-1c-.3 0-.7.1-1 .2-.3-.1-.7-.2-1-.2M103.1 29.8h.7v-5.1l2.3 3.3 2.3-3.3v5.1h.7v-6.2h-.7l-2.3 3.4-2.3-3.4h-.7v6.2zm7 0h.7l.7-1.7h3.4l.7 1.7h.8l-2.8-6.3h-.7l-2.8 6.3zm1.7-2.3 1.4-3.2 1.4 3.2h-2.8zm8.1-1.3v-.7l-1.6.7v-2.7h-.7v3l-.7.3v.7l.7-.3v2.5h4.2V29h-3.5v-2.2l1.6-.6zm5.6 3.7c1.9 0 3.2-1.5 3.2-3.2 0-1.7-1.3-3.2-3.2-3.2s-3.2 1.5-3.2 3.2c0 1.7 1.3 3.2 3.2 3.2m0-.7c-1.4 0-2.5-1.2-2.5-2.6 0-1.4 1-2.6 2.4-2.6s2.5 1.2 2.5 2.6c.1 1.5-1 2.6-2.4 2.6m4.4.6h.7v-2.2h1.5c1.3 0 2.4-.7 2.4-2 0-1.2-.9-2-2.3-2h-2.3v6.2zm.7-2.9v-2.7h1.6c1 0 1.7.5 1.7 1.4 0 .8-.7 1.4-1.7 1.4h-1.6zm8 3c1.9 0 3.2-1.5 3.2-3.2 0-1.7-1.3-3.2-3.2-3.2-1.9 0-3.2 1.5-3.2 3.2 0 1.7 1.3 3.2 3.2 3.2m0-.7c-1.4 0-2.5-1.2-2.5-2.6 0-1.4 1-2.6 2.4-2.6s2.5 1.2 2.5 2.6c0 1.5-1 2.6-2.4 2.6m4.4.6h4.2v-.7h-3.5v-5.6h-.7v6.3zm7.4.1c1.2 0 2.1-.7 2.1-1.8 0-1-.6-1.5-2-1.8-1.4-.3-1.7-.6-1.7-1.2s.5-1 1.3-1c.6 0 1.2.2 1.8.7l.4-.5c-.6-.5-1.3-.8-2.2-.8-1.2 0-2 .7-2 1.7s.7 1.5 2.1 1.8c1.3.3 1.6.6 1.6 1.2s-.6 1.1-1.4 1.1c-.9 0-1.5-.3-2.1-.9l-.4.5c.7.6 1.5 1 2.5 1m3.4-.1h.7v-1.7l1.3-1.3 2.4 3h.9l-2.8-3.5 2.7-2.7h-.9l-3.6 3.7v-3.7h-.7v6.2zm5.6 0h.7l.7-1.7h3.4l.7 1.7h.8l-2.8-6.3h-.7l-2.8 6.3zm1.7-2.3 1.4-3.2 1.4 3.2h-2.8zM59.3 29.8c-.6-1-1.3-1.9-2.2-2.9v2.9h-1.6v-6.2h1.6v2.7c.8-.9 1.5-1.8 2-2.7H61c-.7 1-1.4 2-2.3 3 1.1 1.2 1.7 2.1 2.4 3.2h-1.8zM64.7 27.9zm2.9 1.9h-1.9c-.4-.9-1.2-2-2-3 .2.1.4.1.7.1.6 0 .9-.4.9-1s-.3-1-.9-1h-.9v4.9h-1.7v-6.2h2.7c1.4 0 2.4.9 2.4 2.2 0 .8-.3 1.4-.8 1.7.4.5 1 1.4 1.5 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M70.3 27.6h1.4c-.2-.5-.5-.9-.7-1.4-.3.5-.5.9-.7 1.4m1.9 1.4h-2.5l-.4.8h-1.8c1-2.1 2.3-4.5 3.3-6.3h.2c1.1 1.9 2.3 4.2 3.3 6.3h-1.8l-.3-.8zM78.7 29.8c-.6-1-1.3-1.9-2.2-2.9v2.9h-1.6v-6.2h1.6v2.7c.8-.9 1.5-1.8 2-2.7h1.9c-.7 1-1.4 2-2.3 3 1.1 1.2 1.7 2.1 2.4 3.2h-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m83.2 22.7 1.1.3 1.5-1.3-1.4-.4-1.2 1.4zm2.3 4c0-1.1-.7-1.8-1.7-1.8s-1.7.7-1.7 1.8.7 1.8 1.7 1.8 1.7-.7 1.7-1.8m-5.1 0c0-1.9 1.4-3.2 3.4-3.2s3.4 1.3 3.4 3.2c0 1.9-1.4 3.2-3.4 3.2s-3.4-1.3-3.4-3.2M97.5 23.5c-.9 2.1-2 4.5-2.9 6.3h-.1c-.6-1.1-1.4-2.5-2.1-3.9-.7 1.4-1.4 2.7-2.1 3.9h-.1c-.9-1.9-2-4.2-2.9-6.3H89c.4 1 .9 2.1 1.3 3.1.5-1 1-2.1 1.5-3.1h1c.5 1 1 2.1 1.5 3.1.5-1 .9-2.1 1.3-3.1h1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdc300"
    },
    d: "M30 10.3c-.2-.9-.6-2.8-.6-2.8L23 10.9l-.7.4c-.4.2-.7.5-.9.9-.2.3-.3.5-.5.8-1.7 2.3-2.5 3-5 5.3l13.7-7.1c.3-.2.5-.5.4-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 22.4 1.1-4-.2-.2C24.4 21.6 12 29.7 0 37.4l.1.2c7.7-4.1 17.7-9.3 28.6-14.9.2 0 .3-.1.3-.3",
    style: {
      fill: "#009fe3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4565ad"
    },
    d: "M11 15.4c-.3-.9-3.9-4.2-5.6-5.1l.9 7.5 4.7-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdc300"
    },
    d: "m12.6 17.7-6.1 3.8c-.4.2-.7.6-.8 1-.1.4-.4 1.3-.4 1.3l8.4-4.3-1.1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3 16v-3.4s-2.5 1.3-5.2 2.9S3.3 29.4 3.3 29.4c-.3.2-.5.5-.6.7-.1.3-.2.4-.3.7l27.5-14.2c.2-.1.3-.3.4-.6",
    style: {
      fill: "#e5007d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m29.8 33.3 5.2-2.7c-.6-1-1.1-2-1.6-3 0 0-2.9 1.9-3.4 2.2-.5.3-.4.5-.4.8 0 .3.2 2.7.2 2.7M32.9 26.2l-.6-3.2c-1 1.5-1.8 2.9-2.3 4.5l.2.1 2.7-1.4zM32 37.8l6.8-3.5c-1-.8-1.9-1.6-2.8-2.4l-5.4 3.5 1.4 2.4zM29 66.1c6.1-1.2 11.7-4.7 15.3-10.1-.9.6-14.3 9.3-15.4 10l.1.1zM47.4 48.1 19.7 65.9l.1.2c.4-.1.7-.1 1-.2l24.4-12.6c.5-.3 1.2-.9 1.5-1.5.9-2.2.7-3.7.7-3.7M33.1 40c.1.3.6 2.4.6 2.4l1.1-.6 8.5-4.4c-.9-.8-2.5-1.8-3.3-2.3l-6.8 4.3c0 .2-.1.4-.1.6M33.9 44.9c-.3.2-.6.5-.7.8-.2.4-.3.9-.6 1.3-.3.6-.6 1.3-.8 1.9l6.3-3.3 7.6-4c.2-.1.3-.4.2-.6-.5-1-1.1-2-1.8-2.8l-7.9 5.1-2.3 1.6zM15.1 45.4l-8.4 5.4c0 .1 0 .1.1.2l8.6-4.5-.3-1.1zM17.5 49.7l-8.6 5.5.1.1 9.4-4.9-.9-.7zM25 52.5h-.9c-.6 0-1.2-.1-1.8-.2l-1.8 1.2-9.2 5.9.1.1 9.7-5 3.9-2zM47.2 46.1c0-.6-.1-1-.1-1-.1-.8-.3-1.6-.6-2.4L14 63.7c0 .1 0 0 .1.1l32.7-17c.3-.2.5-.4.4-.7M15.2 40.3c.1-.3.2-.6.3-1.1 0 0-11.2 7.2-11.3 7.3.1 0 .4 0 .5-.1l9.4-4.8c.4-.3.9-.7 1.1-1.3M24.8 30c1-1.2 2-2.7 2.8-4.5 0 0-26.1 16.8-26.2 16.9.2 0 .4-.1.5-.1l21.4-11.1c.6-.3 1.1-.7 1.5-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4565ad"
    },
    d: "M25.5 0c-.1 2.7-1.3 6.6-2.3 9l5.7-3.1L25.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M227.8 44.9c.2-1.1 0-1.3-1.1-1.3s-3.1.1-4.2.1c-1.1.1-1.3.1-1.3.2-.1.1 0 .3.1.4.1.2 2.5 3.9 3.6 5.4.7.9.9 2 1.8-.7.4-1 .9-3 1.1-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M199.4 33.9c1.3-1.4-3.1-1-4.2-1-.8.1-.8.2-.8.9-.1 1 0 2.9.1 3.9s.2 1 .9.3 3.3-3.3 4-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    d: "M200.5 42.7c-1.3 1.5 3.2 1 4.2 1 .8-.1.8-.2.9-.9.1-1 0-3-.1-4s-.2-1-.9-.3c-.7.8-3.4 3.4-4.1 4.2zM210.4 44.4c1.3-1.4-3.1-1-4.1-1-.8.1-.8.2-.8.9-.1 1 0 2.9.1 3.8.1 1 .2 1 .9.3.6-.7 3.2-3.2 3.9-4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M199.7 52.9c1.5 1.3 1-3.3 1-4.4-.1-.8-.2-.8-.9-.9-1.1-.1-3 0-4.1.1-1 .1-1.1.2-.3 1 .7.7 3.4 3.5 4.3 4.2zM211.2 35.1c-1.3-1.2-1 3.1-1 4.2.1.8.2.8.8.8.9 0 2.7-.1 3.6-.2.9-.1.9-.2.3-.9-.7-.8-3-3.3-3.7-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#fff"
    },
    d: "M195 46.4c.1 1.9 3-1.6 3.8-2.3.5-.6.5-.7 0-1.2-.7-.7-2-2-2.8-2.6-.8-.6-.9-.5-.9.5 0 .9-.1 4.5-.1 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5 40.9c-.1-1.9-2.9 1.5-3.6 2.2-.5.6-.4.7 0 1.2.7.8 2 2.1 2.8 2.7.7.6.9.6.9-.4s0-4.7-.1-5.7z",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M201.9 33.2c-2 .1 1.4 3 2.2 3.8.6.5.7.4 1.3 0 .8-.7 2.3-2 3-2.8.7-.8.7-.9-.4-.9-1.1-.1-5-.2-6.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    d: "M208.7 54.1c2.3-.2-1.8-3.5-2.7-4.3-.7-.6-.8-.5-1.5.1-.9.8-2.5 2.4-3.3 3.4-.8.9-.7 1 .5 1 1.3-.1 5.7 0 7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M208.4 33c2 0-1.5-3.1-2.2-3.9-.6-.5-.7-.5-1.3 0-.8.7-2.2 2-2.9 2.8-.7.8-.6.9.4.9 1.1.1 4.9.3 6 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M195.5 38.4c-.6.8 2.7 3.2 3.3 3.9.7.6.8.5 1.4 0 .9-.8 2.5-2.4 3.3-3.2.2-.2.7-.9.8-.9.4-.4-2.7-3.1-3.3-3.8-.7-.6-.8-.5-1.4 0-.9.7-2.5 2.3-3.3 3.2-.4.3-.6.6-.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M215.1 48.6c.6-.8-2.5-3.2-3.2-3.8-.6-.6-.7-.5-1.4 0-.9.8-2.5 2.4-3.2 3.3-.2.2-.7.9-.8.9-.4.4 2.6 3 3.1 3.7.6.6.7.5 1.4 0 .9-.8 2.5-2.4 3.3-3.2.4-.4.6-.7.8-.9zM210.7 34c-1.4-1.6 3.1-1 4.2-.9.8.1.8.2.9 1 .1 1.1.2 3.1.2 4.2s-.2 1.1-.9.3c-.8-.9-3.6-3.7-4.4-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.8
    },
    d: "M215.9 46.6c.1 1.9 2.9-1.4 3.7-2.2.5-.6.4-.7 0-1.2-.6-.8-2-2.1-2.7-2.8-.7-.6-.8-.6-.9.4 0 1-.2 4.7-.1 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M211 53.3c-2 1.7 3.1 1.1 4.1 1.1.8-.1.8-.2.9-.9.1-1 .1-2.9 0-3.9s-.2-1-.9-.3-3.4 3.2-4.1 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M202.3 54.7c-1.9.2 1.8 2.8 2.5 3.5.6.5.7.4 1.2-.1.8-.6 2.1-2 2.7-2.7.6-.7.6-.8-.4-.8-.9 0-4.9 0-6 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    d: "M195.3 49.2c-1.4-1.3-1 3.1-1 4.2.1.8.2.8.9.8 1 .1 2.9 0 3.9-.1s1-.2.3-.9-3.3-3.3-4.1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M194.7 40.3c-.1-1.9-3.2 1.7-4 2.5-.6.6-.5.7 0 1.3l2.7 2.7c.7.8 1.3 1.6 1.3-1 0-1 .1-4.4 0-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M222 28.8c-.7-.9-.9-.9-1.7-.1-.8.8-2.1 2.3-2.8 3.1-.7.8-.8 1-.8 1.1 0 .1.2.2.4.2s4.5.8 6.4 1.1c1.1.2 2.1.7.7-1.8-.4-1-1.5-2.7-2.2-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M220 26.7c.9.6.9.9.2 1.7-.7.8-2.2 2.1-3 2.9-.8.7-1 .9-1.1.8-.1 0-.2-.2-.2-.4s-1-4.5-1.3-6.3c-.2-1.1-.8-2.1 1.8-.8.9.4 2.7 1.5 3.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M203.7 21.6c1.1-.2 1.3 0 1.3 1.1s-.1 3.1-.2 4.2-.1 1.3-.2 1.3c-.1.1-.3 0-.4-.2-.2-.1-3.8-2.6-5.3-3.7-.9-.7-2-1 .8-1.8.9-.3 2.9-.8 4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M188.1 29.1c.7-.9.9-.9 1.7-.2.8.7 2.1 2.2 2.9 3.1.7.8.8 1 .8 1.1 0 .1-.2.2-.4.2s-4.5.9-6.4 1.2c-1.1.2-2.1.8-.8-1.8.5-1 1.6-2.7 2.2-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M206.7 21.4c-1.1-.2-1.3 0-1.3 1 0 1.1 0 3.1.1 4.2s.1 1.3.2 1.3c.1.1.3 0 .4-.1.2-.1 3.9-2.5 5.4-3.5 1-.7 2-.9-.7-1.8-1-.4-3-.9-4.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M190.4 26.9c-.9.7-.9.9-.2 1.7.7.8 2.2 2.1 3.1 2.8.8.7 1 .8 1.1.8.1 0 .2-.2.2-.4s.9-4.5 1.2-6.4c.2-1.1.8-2.1-1.8-.8-.9.5-2.7 1.6-3.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6 42c-.1 1.1 0 1.3 1.1 1.3s3.1-.1 4.2-.2 1.3-.1 1.3-.2c.1-.1 0-.3-.2-.4-.1-.2-2.6-3.8-3.7-5.3-.7-.9-.9-2-1.8.8-.3.9-.8 2.9-.9 4z",
    style: {
      opacity: 0.55,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M188.4 58.3c.7.9.9.9 1.7.1.8-.8 2.1-2.3 2.8-3.1.7-.8.8-1 .8-1.1 0-.1-.2-.2-.4-.2s-4.5-.8-6.4-1.1c-1.1-.2-2.1-.7-.7 1.8.4 1 1.5 2.7 2.2 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#fff"
    },
    d: "M182.6 45.1c-.2-1.1 0-1.3 1.1-1.4 1.1 0 3.2.1 4.3.1 1.1.1 1.3.1 1.4.2.1.1 0 .3-.1.5s-2.6 4-3.7 5.6c-.7 1-.9 2.1-1.9-.7-.4-1-.9-3.1-1.1-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M190.6 60.7c-1-.6-1-.9-.3-1.7.7-.9 2-2.6 2.8-3.4.8-.8.8-.9 1-.8.1 0 .5.5.5.7.1.2 1.2 4.6 1.6 6.5.3 1.2.9 2.1-1.8.9-.9-.6-2.8-1.6-3.8-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    d: "M207.1 65.9c-1.1.2-1.3.1-1.4-1-.1-1.1 0-3.2 0-4.3 0-1.1.1-1.3.2-1.4.1-.1.3 0 .5.1s4.1 2.5 5.7 3.5c1 .7 2.1.9-.7 1.9-1.1.4-3.2 1-4.3 1.2zM222.5 58.1c-.6 1-.9 1-1.7.3-.8-.7-2.3-2.2-3.1-3.1-.8-.8-.9-1-.9-1.1 0-.1.2-.2.4-.2.2-.1 4.7-1.2 6.5-1.6 1.2-.3 2.1-.9.9 1.8-.5 1.1-1.5 3-2.1 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M227.8 41.8c.2 1.1 0 1.3-1.1 1.4-1.1.1-3.2 0-4.3-.1-1.1-.1-1.3-.1-1.4-.2-.1-.1 0-.3.1-.5s2.6-4 3.7-5.6c.7-1 .9-2.1 1.9.7.4 1.1.9 3.1 1.1 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#fff"
    },
    d: "M203.9 65.8c1.1.2 1.3 0 1.3-1.1s-.1-3.1-.2-4.2-.1-1.3-.2-1.3c-.1-.1-.3 0-.4.1-.2.1-3.8 2.6-5.4 3.6-.9.7-2 .9.7 1.8 1.1.5 3.1.9 4.2 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M220 60.3c.9-.7.9-.9.2-1.7-.7-.8-1.9-2.3-2.7-3-.8-.7-1.3-.7-1.4-.6-.1 0-.2.2-.2.4s-.9 4.5-1.2 6.4c-.2 1.1-.8 2.1 1.8.8.8-.6 2.6-1.7 3.5-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    d: "M200.7 32.3c.6-.2 4.1-3.1 3.5-3.7-.8-.7-6.8-5.1-7.3-5.1-.3.1-1.3 5.7-1.9 8.4-.2.8 3.7.7 5.2.5.2 0 .4-.1.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M206.7 58.5c.7.6 6.4 4.7 6.9 4.7.3-.1 1.2-5.3 1.7-7.9.2-.8-3.5-.6-4.9-.4-.6.1-4.2 3.1-3.7 3.6zM200.1 54.7c-.5-.3-5-.3-4.9.5.1 1 1.7 8.3 2 8.6.2.1 4.7-3.4 6.9-5 .7-.5-2.1-2.5-3.2-3.6 0-.2-.7-.5-.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M193.9 48.3c-.2-.6-3.4-4.5-3.9-3.9-.7.8-5 7-5 7.5.1.3 5.7 1.2 8.4 1.7.8.3.5-5.2.5-5.3zM216.7 39.4c.2.6 3.2 3.7 3.7 3.1.7-.8 5-6.9 5-7.4-.1-.3-5.7-1.2-8.4-1.7-.8-.2-.7 3.7-.5 5.1 0 .2.1.8.2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M210.3 32.6c.5.3 4.9.1 5-.4-.1-1-1.3-8.2-1.6-8.5-.2-.1-4.8 3.1-7 4.6-.7.4 1.9 2.9 2.9 4 .1 0 .6.2.7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M193.9 38.7c.3-.5.3-5.1-.5-5-1 .1-8.2 1.6-8.5 1.9-.1.2 3.3 4.7 4.9 6.9.5.7 2.9-2 3.7-3.2.2-.2.4-.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M216.7 48.2c-.2.5-.4 5.6.4 5.5 1-.1 8.1-2 8.4-2.4.1-.2-3.2-4.4-4.8-6.6-.5-.7-2.6 1.4-3.4 2.6l-.6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#fff"
    },
    d: "M210.8 40.4c-.7 0-.7.1-.6.6.2.5.6 1.3.8 1.7.3.4.4.4.9 0s1.4-1.3 1.8-1.7c.4-.5.4-.5-.3-.6h-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M199.2 44.2c.7-.6.8-.5 1.1 0 .3.6.6 1.7.7 2.3.1.6 0 .7-.8.8-.8.1-2.4 0-3.3-.1-.8-.1-.8-.2-.2-.8.6-.5 1.8-1.6 2.5-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M204.9 48.4c-.1.8-.2.8-.7.7-.5-.2-1.4-.6-1.9-.9-.5-.3-.4-.4 0-1 .5-.6 1.4-1.5 2-2 .5-.5.6-.4.6.3.2.7.1 2.1 0 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M202.3 46.6c-.5.4-.7.4-.9 0-.2-.4-.5-1.3-.6-1.8-.1-.5 0-.6.7-.6h2.6c.6.1.7.1.2.6-.5.5-1.5 1.3-2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "M209.8 43.2c.8 0 .8-.1.7-.6-.2-.5-.6-1.4-.9-1.9-.3-.5-.4-.4-1 0s-1.6 1.4-2 1.9c-.5.5-.4.6.3.6h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "M208.4 40.1c.5-.5.5-.6.1-.9-.4-.2-1.3-.6-1.8-.7-.5-.1-.5 0-.6.6-.1.7-.2 1.9-.2 2.6 0 .6.1.7.6.2.5-.4 1.4-1.3 1.9-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M203.8 50c.5-.5.5-.7 0-.9-.5-.3-1.5-.7-2-.8-.5-.2-.6-.1-.7.6-.1.7-.2 2.1-.1 2.8 0 .7.1.7.7.3.6-.5 1.6-1.4 2.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M206.4 36.7c-.7.7-.7.9-.2 1.2.6.3 1.7.9 2.3 1.1.6.2.7.1 1-.9.2-1 .4-2.8.5-3.7.1-.9 0-1-.8-.4-.7.7-2.1 2-2.8 2.7z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "logofooter",
    viewBox: "0 0 345.4 143.1"
  }, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}.st1{fill:#eec216}.st4{fill:#5165aa}.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#c4007a}\n        ")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M75.9 77.8c.6.7 1.2 1.5 1.7 2.3l14.6-7.5c-.7-.5-1.5-1-2.3-1.5-1.5-.9-2.9-1.9-4.2-3.1l-11.6 7.5c.6.8 1.2 1.6 1.8 2.3M46.3 82.4 21 98.7l24.2-12.5c.2-1.3.6-2.6 1.1-3.8M46.2 96.4c-.3-.8-.6-1.5-.8-2.3l-21.3 13.7 22.1-11.4zM50.1 102.1l-21.4 13.8.1.1 23.5-12.1c-.8-.5-1.5-1.2-2.2-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eec216"
    },
    d: "m32.9 50.1 11.5-5.9c-.7-1.2-1.4-2.3-2.1-3.4l-8.8 5.7c-.1 1.2-.3 2.4-.6 3.6M73.8 29c-.5-2.5-1.2-4.9-2-7.3l-10.2 6.5C59 33.6 55 38 50.1 41.2L73.8 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M62.6 107.2c-1 0-1.9-.1-2.9-.2L35 122.9c.1.1.2.2.4.3l32.9-16.9c-1.9.6-3.8.9-5.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 36.9c0-1.9-.1-3.8-.4-5.6L29.7 59.9c-.5 1.2-1.1 2.3-1.8 3.4l46.4-23.9c.1-.9.2-1.7.2-2.5",
    style: {
      fill: "#c4007a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.9 76-.3 1.2 50.5-26c.8-2.2 1.4-4.4 1.8-6.7.1-.7.2-1.4.3-2.2L21.9 76z",
    style: {
      fill: "#009de0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m80.3 89.5 19.2-9.9c-1.6-2.1-3.5-4-5.5-5.7l-14.7 9.5c.6 1.9 1 3.9 1 6.1M104.4 89.2 43 128.7c.4.2.7.4 1.1.6l61.8-31.8c-.1-2.9-.6-5.7-1.5-8.3M106 99.3 53.6 133c.9.2 1.8.5 2.7.6l48.2-24.8c.9-3 1.4-6.2 1.5-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5165aa"
    },
    d: "m63.4 23.8 7.6-3.9c-1.6-3.8-3.8-7.2-6.4-10.3.2 1.5.3 3 .3 4.5-.1 3.4-.6 6.6-1.5 9.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M68.5 134.5c9.6-.7 18.4-4.3 25.5-10.1.1-.1.2-.1.3-.2 0 0 .1 0 .1-.1 0 0 .1 0 .1-.1.1-.1.2-.1.2-.2 3.7-3.2 6.7-7.2 8.6-11.8l-34.8 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5165aa"
    },
    d: "M38.9 36.4c-2-2.3-4.3-4.4-6.8-6.2.8 2.9 1.3 5.8 1.5 8.9l5.3-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M79.7 94.1c-1.1 4-3.5 7.4-6.7 9.8l31.1-16c-.9-2.5-2.2-4.9-3.7-7.1L79.7 94.1zM71.5 66.2v.6c.1 1.9.4 3.7 1 5.4L84 66.3c-1.5-1.7-2.8-3.6-3.8-5.7l-8.7 5.6zM72 61.8l7.2-3.7c-.6-1.8-1-3.7-1.2-5.7-2.9 2.4-5 5.6-6 9.4M20 88.6 62 67c3.2-3.2 5.9-6.8 7.9-10.8L20 88.3v.3M181 127.3h3.5v-1.9H181V124h4v-1.9h-6.3v8.6h6.3v-1.9h-4zM192 127.5c0 .9-.7 1.4-1.6 1.4-1 0-1.7-.6-1.7-1.4v-5.3h-2.3v5.7c0 1.7 1.6 2.9 3.9 2.9 2.4 0 3.9-1.2 3.9-2.9v-5.7H192v5.3zM203.1 125.1c0-1.8-1.3-3-3.3-3H196v8.5h2.3V124h1.2c.7 0 1.2.5 1.2 1.3s-.4 1.4-1.2 1.4c-.3 0-.6 0-.9-.1 1.1 1.3 2.2 2.9 2.7 4.1h2.6c-.6-1.2-1.5-2.4-2-3.2.7-.5 1.2-1.3 1.2-2.4M208.9 122c-2.8 0-4.7 1.8-4.7 4.4 0 2.6 1.9 4.4 4.7 4.4 2.8 0 4.6-1.7 4.6-4.4.1-2.6-1.8-4.4-4.6-4.4m0 6.9c-1.4 0-2.3-1-2.3-2.5s.9-2.5 2.3-2.5 2.3 1 2.3 2.5c.1 1.5-.9 2.5-2.3 2.5M218.7 122.1h-3.8v8.5h2.3v-2.4h1.4c2 0 3.3-1.3 3.3-3.1-.1-1.8-1.3-3-3.2-3m-.2 4.3h-1.3V124h1.3c.6 0 1 .5 1 1.2s-.4 1.2-1 1.2M225.3 127.3h3.5v-1.9h-3.5V124h4v-1.9H223v8.6h6.3v-1.9h-4zM234.3 122c-1.5 2.5-3.2 5.8-4.6 8.6h2.4c.2-.4.3-.7.5-1.1h3.5c.2.4.3.7.5 1.1h2.4c-1.4-2.9-3.1-6.1-4.6-8.6h-.1zm-.9 5.7c.3-.6.7-1.3 1-1.9.3.6.7 1.3 1 1.9h-2zM246 126.7l-1.2-1c-2-1.7-4.3-3.7-5.1-3.7v8.6h2.3v-4.5l1.3 1c2 1.7 4.3 3.6 5 3.6v-8.6H246v4.6zM256.8 126.8h2.3v2.8c-.6.2-1.3.3-1.8.3-2.2 0-3.3-1.4-3.3-3.5 0-2.2 1.3-3.5 3.4-3.5.7 0 1.7.2 2.3.4v-.8c-.8-.3-1.8-.5-2.6-.5-2.5 0-4.2 1.7-4.2 4.4 0 2.5 1.5 4.3 4.2 4.3.6 0 1.4-.1 2-.3.3.2.6.3 1 .3v-4.8h-3.3v.9zM265.1 122c-1.4 2.5-2.9 5.8-4.1 8.6h1.1c.3-.7.5-1.4.8-2h4.4c.3.7.6 1.4.8 2h1.1c-1.2-2.9-2.7-6.1-4.1-8.6zm-1.8 5.8c.6-1.4 1.2-2.7 1.8-4 .6 1.2 1.3 2.6 1.8 4h-3.6zM275.1 128.1c-1.2-1.9-4-6-4.6-6v8.6h1v-6.2c1 1.3 2.7 3.9 3.5 5.2h.1c.8-1.4 2.5-3.9 3.5-5.2v6.2h1V122c-.5 0-3.2 4.2-4.5 6.1M283.2 126.7h4v-.8h-4V123h4.3v-.9h-5.4v8.6h5.5v-.9h-4.4zM292.3 125.8l-.5-.1c-1-.2-1.8-.5-1.8-1.4 0-.9.7-1.4 2.1-1.4.7 0 1.5.2 2.3.5v-.8c-.9-.4-1.8-.5-2.6-.5-1.8 0-2.9.9-2.9 2.4s1 1.9 2.3 2.2l.5.1c1.2.3 2 .7 2 1.7 0 .9-.7 1.5-2.1 1.5-.7 0-1.6-.2-2.4-.6v.8c.7.4 1.8.6 2.7.6 1.8 0 2.9-.9 2.9-2.5s-1.1-2.2-2.5-2.5M161.2 126.9c.4-.1.8-.3 1-.6.3-.3.4-.6.4-1.1 0-.4-.1-.7-.3-1-.2-.3-.5-.5-.8-.6-.3-.2-.7-.3-1-.4-.4-.1-.7-.1-1.1-.1-.5 0-.9 0-1.3.1-.4 0-.8.1-1.1.2v1.7c.2-.1.5-.1.8-.2.3-.1.7-.1 1-.1h.4c.1 0 .2.1.4.1.1.1.2.1.3.2.1.1.1.2.1.4s-.1.3-.2.4c-.1.1-.2.1-.4.2-.1 0-.3.1-.5.1h-1v1.6c.2 0 .3 0 .5-.1h.9c.1 0 .3.1.4.1.1.1.2.1.3.2.1.1.1.2.1.4 0 .1 0 .3-.1.3-.1.1-.2.2-.3.2-.1 0-.2.1-.4.1h-.5c-.4 0-.7 0-1-.1-.3-.1-.6-.1-.8-.2v1.7c.2 0 .4.1.6.1.2 0 .4.1.7.1.2 0 .5 0 .7.1h.7c.4 0 .8 0 1.2-.1.4-.1.7-.2 1.1-.4.3-.2.6-.4.8-.7.2-.3.3-.6.3-1 0-.5-.1-.9-.4-1.1-.7-.2-1.1-.4-1.5-.5M172 125c-.4-.2-.9-.3-1.3-.3-.9 0-1.6.3-2.1.8-.5.6-.8 1.3-.8 2.2 0 .9.3 1.6.8 2.2.5.6 1.2.8 2 .8.6 0 1.2-.1 1.8-.4.5.3 1.1.4 1.7.4v-8.5l-2 .6v2.2zm0 3.9c-.3.2-.6.2-.9.2-.4 0-.7-.1-.9-.4-.2-.3-.3-.6-.3-1.1 0-.4.1-.8.4-1.1.3-.3.6-.4 1-.4.2 0 .5.1.8.2v2.6zM163.6 124.7v5.9h2v-3.8c.5-.2 1-.2 1.7-.2v-1.9c-.7 0-1.3.2-1.9.5-.5-.3-1.1-.5-1.8-.5M321.3 58.1l2.7-6 2.7 6h-5.4zm-3.3 4.3h1.4l1.4-3.1h6.4l1.4 3.1h1.4l-5.4-11.9h-1.2L318 62.4zm-10.6 0h1.3v-3.2l2.5-2.5 4.5 5.7h1.7l-5.3-6.6 5-5.1h-1.7l-6.8 7v-7h-1.3v11.7zm-6.3.2c2.3 0 4-1.3 4-3.3 0-1.8-1.2-2.8-3.8-3.3-2.6-.6-3.2-1.2-3.2-2.3 0-1.1 1-1.9 2.5-1.9 1.2 0 2.3.4 3.4 1.3l.8-1c-1.2-1-2.4-1.4-4.1-1.4-2.2 0-3.9 1.4-3.9 3.2 0 1.9 1.2 2.8 4 3.4 2.5.5 3.1 1.1 3.1 2.2 0 1.2-1 2-2.6 2s-2.8-.6-4-1.7l-.8 1c1.2 1.2 2.8 1.8 4.6 1.8m-14-.2h8v-1.2h-6.6V50.7h-1.3v11.7zm-8.4-1c-2.7 0-4.6-2.2-4.6-4.9s1.9-4.8 4.6-4.8c2.7 0 4.6 2.2 4.6 4.9s-1.9 4.8-4.6 4.8m0 1.2c3.6 0 6-2.8 6-6.1 0-3.2-2.4-6.1-6-6.1s-6 2.8-6 6.1 2.4 6.1 6 6.1m-15-5.5v-5.2h3c1.9 0 3.2.9 3.2 2.6 0 1.5-1.3 2.6-3.2 2.6h-3zm-1.3 5.3h1.3v-4.2h2.9c2.5 0 4.6-1.3 4.6-3.9 0-2.3-1.7-3.7-4.4-3.7h-4.4v11.8zm-8.4-1c-2.7 0-4.6-2.2-4.6-4.9s1.9-4.8 4.6-4.8c2.7 0 4.6 2.2 4.6 4.9s-1.9 4.8-4.6 4.8m0 1.2c3.6 0 6-2.8 6-6.1 0-3.2-2.4-6.1-6-6.1s-6 2.8-6 6.1 2.4 6.1 6 6.1m-10.5-6.9v-1.3l-3 1.4v-5.1h-1.3v5.7l-1.3.6v1.3l1.3-.6v4.7h8v-1.2h-6.6v-4.1l2.9-1.4zm-15.4 2.4 2.7-6 2.7 6h-5.4zm-3.3 4.3h1.4l1.4-3.1h6.4l1.4 3.1h1.4l-5.4-11.9h-1.2l-5.4 11.9zm-13.2 0h1.3v-9.5l4.3 6.3h.1l4.3-6.3v9.5h1.3V50.7h-1.3l-4.3 6.4-4.3-6.4h-1.3v11.7zM128.9 62.4c-1.2-1.8-2.5-3.5-4.1-5.4v5.4h-3.1V50.7h3.1v5.1c1.5-1.8 2.8-3.4 3.8-5.1h3.5c-1.2 1.9-2.6 3.7-4.3 5.7 2.1 2.3 3.2 4 4.6 6.1h-3.5zM144.5 62.4h-3.6c-.8-1.7-2.3-3.8-3.8-5.6.4.1.8.2 1.3.2 1.1 0 1.7-.7 1.7-1.9 0-1.1-.7-1.9-1.7-1.9h-1.7v9.2h-3.1V50.7h5.1c2.7 0 4.6 1.6 4.6 4.1 0 1.5-.7 2.6-1.6 3.3.8 1.1 1.9 2.7 2.8 4.3m-5.4-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M153.3 60.9h-4.8l-.7 1.5h-3.3c2-4 4.3-8.4 6.3-11.9h.2c2 3.5 4.4 8 6.3 11.9H154l-.7-1.5zm-3.7-2.5h2.7c-.4-.9-.9-1.8-1.4-2.6-.4.8-.9 1.7-1.3 2.6M165.6 62.4c-1.2-1.8-2.5-3.5-4.1-5.4v5.4h-3.1V50.7h3.1v5.1c1.5-1.8 2.8-3.4 3.8-5.1h3.5c-1.2 1.9-2.6 3.7-4.3 5.7 2.1 2.3 3.2 4 4.6 6.1h-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M168.8 56.5c0-3.6 2.6-6 6.4-6 3.8 0 6.4 2.4 6.4 6s-2.6 6-6.4 6c-3.8.1-6.4-2.3-6.4-6m9.6 0c0-2.1-1.3-3.5-3.2-3.5-1.9 0-3.2 1.4-3.2 3.5s1.3 3.5 3.2 3.5c1.9 0 3.2-1.4 3.2-3.5m-4.4-7.4 2 .6 2.8-2.4-2.7-.8-2.1 2.6zM201 50.7c-1.7 4-3.8 8.4-5.6 11.9h-.2c-1.2-2.2-2.6-4.7-3.9-7.3-1.3 2.6-2.7 5.1-4 7.3h-.1c-1.8-3.5-3.8-8-5.5-11.9h3.3c.8 1.9 1.7 3.9 2.5 5.9 1-2 1.9-4 2.8-5.9h1.9c.9 1.9 1.8 3.9 2.8 5.9.9-2 1.7-4 2.5-5.9h3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.4 69c-12.9 0-23.3 10.3-23.3 23.2 0 13 10.5 23.5 23.4 23.4 12.9-.1 23.2-10.4 23.2-23.4-.1-12.9-10.4-23.2-23.3-23.2m-.1 34.8c-6.4 0-11.6-5.3-11.5-11.8.1-6.3 5.3-11.3 11.7-11.2 6.3.1 11.5 5.3 11.4 11.6-.1 6.3-5.2 11.4-11.6 11.4",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5165aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    },
    d: "M133 96.1h21.1V87h-21v-7.7h23.7v-9.5h-35.1v45h35.4v-9.6H133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#aec538"
    },
    d: "M306.9 115.4v-11l-19.7 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.4 79.2c-2-4.5-6.6-10.1-17-10h-1.2v9.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7v12.4s10.1-5 15.4-9.5c1-.8 1.7-1.7 2.3-2.7 0 0 .6-1.2.7-1.2 1.9-4.5 1.7-10.3-.2-14.1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009de0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#c4007a"
    },
    d: "M231.7 115.4v-11l-19.7 11zM230.1 79.2c-2-4.5-6.6-10.1-17-10h-1.2v9.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7v12.4s10.1-5 15.4-9.5c1-.8 1.7-1.7 2.3-2.7 0 0 .6-1.2.7-1.2 2-4.5 1.7-10.3-.2-14.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7 88c.1-.2 3.3-4.3 2.1-9.8 0 0-1.8-8.1-11.7-9v8c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5v7c2.1 0 4 1.1 5.1 2.7.7 1 1 2.1 1.1 3.4 0 3.4-2.9 6.2-6.3 6.2h-.1v9.8c.3 0 10.3.9 15.2-9.9-.1 0 4.2-10.4-5.4-17.4",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eec216"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M200.7 77.6c-4.1-5.6-10.5-8.5-17.7-8.4h-2c-.7.1-1.5.1-2.2.2-12.6 1.8-21.7 14.5-19.2 26.8 1.7 8.2 6.2 13.9 13.5 17-4.2-2-7.7-5.1-10.1-9.1 2.4 4 5.9 7.1 10.1 9.1 1 .4 2 .8 3.1 1.1 2.8.8 5.5 1.1 8 1-2.6.1-5.3-.2-8-1-1.1-.3-2.1-.7-3.1-1.1 3 1.4 6.3 2.1 9.7 2.1.5 0 1 0 1.6-.1 7-.5 13.2-4.1 17.1-9.4.1-5.3 0-10.6 0-16.1H183v7.5h11.1v.1c-1.2 2.5-3.1 4.6-5.6 5.8-1.7.9-3.6 1.4-5.7 1.4-6.8 0-12.3-5.5-12.3-12.3 0-3.7 1.6-7 4.2-9.2 3.6-3.4 8.9-4.3 13.5-1.9.2.1.4.2.5.3.5.3.9.6 1.4.9.3.2.9.7.9.7l9.7-5.4"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "tiktok",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.32 128.39c-29.22 0-56.18-9.68-77.83-26.01-24.83-18.72-42.67-46.18-48.97-77.83A129.78 129.78 0 0 1 351.04.39h-83.47v228.08l-.1 124.93c0 33.4-21.75 61.72-51.9 71.68a75.905 75.905 0 0 1-28.04 3.72c-12.56-.69-24.33-4.48-34.56-10.6-21.77-13.02-36.53-36.64-36.93-63.66-.63-42.23 33.51-76.66 75.71-76.66 8.33 0 16.33 1.36 23.82 3.83v-84.75c-7.9-1.17-15.94-1.78-24.07-1.78-46.19 0-89.39 19.2-120.27 53.79-23.34 26.14-37.34 59.49-39.5 94.46-2.83 45.94 13.98 89.61 46.58 121.83 4.79 4.73 9.82 9.12 15.08 13.17 27.95 21.51 62.12 33.17 98.11 33.17 8.13 0 16.17-.6 24.07-1.77 33.62-4.98 64.64-20.37 89.12-44.57 30.08-29.73 46.7-69.2 46.88-111.21l-.43-186.56a210.864 210.864 0 0 0 46.88 27.34c26.19 11.05 53.96 16.65 82.54 16.64v-83.1c.02.02-.22.02-.24.02z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408C411.872 60.704 384.416 48 354.464 48c-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44C46.496 446.88 101.6 464 161.024 464c193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "youtube",
    viewBox: "0 0 409.592 409.592"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.882 107.206c-2.15-17.935-19.052-35.133-36.736-37.437a1316.32 1316.32 0 0 0-324.685 0C24.762 72.068 7.86 89.271 5.71 107.206c-7.613 65.731-7.613 129.464 0 195.18 2.15 17.935 19.052 35.149 36.751 37.437a1316.32 1316.32 0 0 0 324.685 0c17.684-2.284 34.586-19.502 36.736-37.437 7.614-65.71 7.614-129.449 0-195.18zM170.661 273.074V136.539l102.4 68.27-102.4 68.265z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg2023Sprites);
export default __webpack_public_path__ + "static/media/EG2023sprites.8f1f4fdeb80a94eb4abe637edd656ef3.svg";
export { ForwardRef as ReactComponent };